/**
 * FoundationYearPill — small pathway pill shown wherever a degree
 * carries `foundation_year: true`. Answers "can I get in via Year 0?"
 * at a glance without the user needing to know to toggle the filter.
 *
 * Rendered on:
 *   - DegreeDetail hero (below the title)
 *   - AdvancedResults degree cards (alongside qualification type)
 *   - Any other card that surfaces a degree summary
 *
 * Clickable → deep-links to `/pathways/foundation-year` so a family
 * new to the concept gets the explainer, then bounces back with
 * context.
 */
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function FoundationYearPill({ show, size = "sm" }) {
  if (!show) return null;
  return (
    <Link
      to="/pathways/foundation-year"
      data-testid="foundation-year-pill"
      title="This degree offers a Year 0 foundation route — click to learn how it works"
      className={
        "inline-flex items-center gap-1 rounded-full border border-emerald-400 bg-emerald-50 text-emerald-900 font-underground-sc tracking-wider hover:bg-emerald-100 transition-colors " +
        (size === "sm"
          ? "text-[10px] px-1.5 py-0.5"
          : "text-[11px] px-2 py-0.5")
      }
      onClick={(e) => {
        e.stopPropagation();
        trackEvent("foundation_pill_click", { size });
      }}
    >
      <GraduationCap className="h-2.5 w-2.5" aria-hidden />
      Foundation year available
    </Link>
  );
}
